module.exports = __webpack_public_path__ + "static/media/personalisation.c5f4e7ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/personalisation.svg
// module id = 182
// module chunks = 0